import React from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import classNames from "classnames";
import ContentItem from "shared/components/cms/ContentItem";
import { ActionRootContext } from "higher-order/ActionRoot";
import { KEYCODES } from "util/constants";

class Flash extends React.Component {
    static contextType = ActionRootContext;

    static propTypes = {
        id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        message: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]),
        contentKey: PropTypes.string,
        timeout: PropTypes.number,
        className: PropTypes.string,
        closeable: PropTypes.bool,
        icon: PropTypes.string,
        link: PropTypes.shape({
            label: PropTypes.string,
            href: PropTypes.string
        }),
        containerId: PropTypes.string
    }

    static defaultProps = {
        id: Math.floor(new Date().getTime()),
        className: "success",
        closeable: true
    }

    componentDidMount() {
        let self = this;
        if (this.props.timeout && this.props.timeout > 0) {
            setTimeout(() => {
                self.handleCloseButton();
            }, this.props.timeout);
        }
    }

    @autobind
    handleCloseButton(e) {
        if (e) {
            e.preventDefault();
        }
        this.context.dispatcher.emit("HIDE_FLASH_MESSAGE", {
            messageId: this.props.id,
            containerId: this.props.containerId
        });
    }

    @autobind
    handleKeyUp(e) {
        if (e.keyCode === KEYCODES.ENTER) {
            e.preventDefault();
            this.props.link.onClick();
        }
    }

    render() {
        return (
            <div className={classNames("flash-message", this.props.className)}>
                {this.props.closeable &&
                    <button className="close-button" title="Close" onClick={this.handleCloseButton}><i className="icon-cancel-circled" /></button>
                }
                <span className="message">
                    {Boolean(this.props.icon) && <i className={"icon icon-" + this.props.icon} />}
                    {this.props.contentKey
                        ? <ContentItem tag="span" contentKey={this.props.contentKey} />
                        : this.props.message
                    }
                    {Boolean(this.props.link) && <a onClick={this.props.link.onClick} onKeyUp={this.handleKeyUp} role="button" tabIndex={0}>{this.props.link.label}</a>}
                </span>
            </div>
        );
    }
}

export default Flash;
